<template>
  <div class="search_form_container">
    <div class="search_form" :style="searchFormFlex">
      <el-form label-position="right" label-width="auto" ref="searchForm" :model="formModel" class=""
        :disabled="disabled" @submit.prevent>
        <el-row>
          <transition-group name="slide-fade">
            <el-col class="search_form_col" :span="formItem.span || formItemWidth"
              v-for="(formItem, formItemIndex) in formData" v-show="isExpanded || formItemIndex < 3"
              :key="formItem.fieldName">
              <el-form-item v-bind="formItem">
                <template v-if="formItem.type === 'input'">
                  <el-input type="text" v-model.trim="formModel[formItem.fieldName]" v-bind="formItem.attrs || {}"
                    v-on="formItem.vOn || {}" :prefix-icon="Search" :clearable="formItem.attrs?.clearable ?? true"
                    @change="debounceInput($event, { formItem, formModel })">
                  </el-input>
                </template>
                <template v-else-if="formItem.type === 'select'">
                  <el-select style="width: 100%" v-model="formModel[formItem.fieldName]" v-bind="formItem.attrs || {}"
                    v-on="formItem.vOn || {}" @change="emit('formChange', { formItem, formModel })"
                    :clearable="formItem.attrs?.clearable ?? isShowClearable">
                    <el-option :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"
                      v-for="item in formItem.options"></el-option>
                  </el-select>
                </template>
                <template v-else-if="formItem.type === 'radioButton'">
                  <el-radio-group style="width: 100%" v-model="formModel[formItem.fieldName]"
                    v-bind="formItem.attrs || {}" v-on="formItem.vOn || {}"
                    @change="emit('formChange', { formItem, formModel })">
                    <el-radio-button :key="item.label" :label="item.value" v-for="item in formItem.options">{{
                      item.label
                      }}</el-radio-button>
                  </el-radio-group>
                </template>

                <template v-else-if="formItem.type === 'cascader'">
                  <el-cascader style="width: 100%" :options="formItem.options" v-model="formModel[formItem.fieldName]" v-bind="formItem.attrs || {}"
                    v-on="formItem.vOn || {}" @change="emit('formChange', { formItem, formModel })"
                    :clearable="formItem.attrs?.clearable ?? isShowClearable">
                  </el-cascader>
                </template>
                <template v-if="formItem.type === 'datePicker'">
                  <el-date-picker
                    :disabledDate="formItem?.attrs?.disabledDate || ((time) => disabledDate(time, formItem?.attrs?.monthNumber))"
                    v-bind="formItem.attrs || {}" v-on="formItem.vOn || {}" v-model="formModel[formItem.fieldName]"
                    :type="formItem?.attrs?.type || 'daterange'" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" :clearable="false" @change="emit('formChange', { formItem, formModel })">
                  </el-date-picker>
                </template>
                <template v-else-if="formItem.type === 'weekPicker'">
                  <el-date-picker :disabledDate="disabledWeek" v-bind="formItem.attrs || {}" v-on="formItem.vOn || {}"
                    v-model="formModel[formItem.fieldName]" type="week" format="ww" :clearable="false"
                    @change="emit('formChange', { formItem, formModel })">
                  </el-date-picker>
                </template>
                <template v-else-if="!!formItem.customize">
                  <slot
                    :name="formItem.fieldName"
                    :item="formItem"
                    :formModel="formModel"
                  />
                </template>
              </el-form-item>
            </el-col>
          </transition-group>
        </el-row>
      </el-form>
    </div>
    <div class="search_btn_container" v-if="btnShow">
      <div class="search_btn">
        <slot name="searchBtn" :scope="{disabled,search,reset}">
          <!-- 默认显示内容 -->
          <el-button type="primary" :icon="Search" @click="search" :disabled="disabled">搜索</el-button>
          <el-button v-if="!hideReset" :icon="Refresh" @click="reset" :disabled="disabled">重置</el-button>
        </slot>
        <div v-if="formDataLength > 3" class="search_btn_expanded" @click="isExpanded = !isExpanded">
          展开
          <el-icon style="color: var(--el-color-primary)">
            <ArrowUpBold v-if="isExpanded" />
            <ArrowDownBold v-else />
          </el-icon>
        </div>
      </div>
    </div>
    <div class="search_empty" :style="searchEmptyFlex"></div>
  </div>
</template>
<script setup>
import { computed, ref, reactive, onBeforeMount } from "vue";
import {
  ArrowUpBold,
  ArrowDownBold,
  Search,
  Refresh,
} from "@element-plus/icons-vue";

import useSearchForm from "./index.js";
import { dayjs } from "element-plus";
dayjs.en.weekStart = 1;
const props = defineProps({
  formData: {
    type: Array,
    default: () => [],
  },
  page: {
    type: Object,
    require: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hideReset: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
  },
  noreset: {
    type: Array,
    default: () => [],
  },
  allowEmpty: {
    type: Array,
    default: () => [],
  },
  btnShow: {
    type: Boolean,
    default: true,
  },
  isShowClearable: {
    type: Boolean,
    default: true,
  },
  //  defaultTimeFieldNames: {
  // 	 type: Array,
  // 	 default: () => [],
  //  },
});

const emit = defineEmits([
  "formChange",
  "searchCallback",
  "resetCallback",
  "update:page",
  "update:data",
]);
const {
  formDataLength,
  formItemWidth,
  searchFormFlex,
  searchEmptyFlex,
  disabledDate, disabledHour, disabledMinute, disabledSecond,
  disabledWeek,
  formModel,
  formData,
  isExpanded,
  search,
  reset,
  debounceInput,
} = useSearchForm(props, emit);
</script>
<style lang="scss" scoped>
.search_form_container {
  display: flex;

  .search_form {
    flex: 1;

    :deep(.search_form_col) {
      label {
        font-weight: unset;
      }
    }

    .slide-fade-enter-active,
    .slide-fade-leave-active {
      transition: all 0.1s ease-in-out;
    }

    .slide-fade-enter,
    .slide-fade-leave-to {
      opacity: 0;
    }

    .search_form_col {
      padding-right: 20px;
    }
  }

  .search_btn_container {

    // margin-left: 50px;
    // flex: 1;
    .search_btn {
      align-items: center;
      display: flex;

      .el-button+.el-button {
        margin-left: 10px;
      }

      .search_btn_expanded {
        cursor: pointer;
        user-select: none;
        margin-left: 15px;
        font-size: 14px;
        width: 50px;
      }
    }
  }
}
</style>
